import React, { useState } from 'react';
import { gql, useQuery } from '@apollo/client';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import parse from 'html-react-parser';
import {
  faInstagram,
  faFacebook,
  faTwitter,
  faYoutube,
  faLinkedin,
} from '@fortawesome/free-brands-svg-icons';
import {
  faEnvelope,
  faPhone,
  faArrowUpRightFromSquare,
  faArrowRight,
} from '@fortawesome/free-solid-svg-icons';
import { Dialog } from 'primereact/dialog';
import { MemberType } from 'types';
import { Link } from 'react-router-dom';

interface MemberProps {
  memberSectionTitle?: string;
  memberSelect?: string;
  memberCardLayout?: string;
}

const GET_MEMBER = gql`
  query GET_MEMBER {
    teamMembers(first: 100) {
      createdAt
      name
      instrument
      spotifyLink
      websiteLink
      tikTokLink
      memberSlug
      miniMemberBio
      companyTitle
      fullBio {
        html
      }
      avatarImage {
        url
      }
      instagramLink
      email
      calendlyLink
      phoneNumber
      facebookLink
      soundcloudLink
      pandoraLink
      epkLink
      youtubeLink
      twitterLink
      linkedinLink
      memberBandsInTown
      memberImageGallery(first: 100) {
        url
      }
      memberMusicRelease(first: 100) {
        url
      }
      memberBookingData
      contactList {
        contactName
        contactEmail
        contactTitle
        contactPhone
        contactAddress
        contactGoogleAddressLink
        contactAvatar {
          id
        }
      }
      videoBox {
        videoTitle
        youtubeVideoId
        vimeoVideoId
        youtubePlaylistId
      }
      primaryMember
      memberHeroImage {
        url
      }
      memberIFrame
      order
      memberType
    }
  }
`;

export default function Member({
  memberSectionTitle,
  memberSelect,
  memberCardLayout,
}: MemberProps) {
  const [visible, setVisible] = useState(false);
  const [selectedMember, setSelctedMember] = useState<MemberType | undefined>();
  const { loading, data } = useQuery(GET_MEMBER);
  if (loading) return <div />;
  const { teamMembers } = data;
  const TotalMembers = teamMembers.length;

  return (
    <div>
      {teamMembers && teamMembers.length && (
        <div className="relative texture-background overflow-hidden">
          <section className="container my-8 relative">
            <div className="grid mx-0 px-4">
              <div className="col-12 md:col-4 lg:col-5 animate-col-width">
                {!!memberSectionTitle && (
                  <h3 className="text-3xl md:text-6xl text-left mt-0 ml-0 gradient-text uppercase max-w-max opacity-80">
                    {memberSectionTitle}
                  </h3>
                )}
              </div>
              <div
                className={`col-12 animate-col-width md:col-8 lg:col-7 grid align-items-center grid mx-auto justify-content-start ${
                  TotalMembers >= 2
                    ? 'justify-content-center'
                    : 'justify-content-start'
                }`}>
                {teamMembers
                  .filter(
                    (member: MemberType) => member?.memberType === memberSelect,
                  )
                  .map((member: MemberType) => (
                    <div
                      key={member.memberSlug}
                      className="col-12 md:col-6 xl:col-4 animate-col-width mx-auto md:mx-0">
                      {memberCardLayout === 'cardModal' ? (
                        <div
                          className={`animate-col-width mx-auto md:mx-0 ${
                            TotalMembers >= 2 ? 'mx-auto' : 'md:mx-0'
                          }`}>
                          <div className="member-card">
                            <img
                              src={member?.avatarImage?.url}
                              alt={(member.name && member.name) || ''}
                              className="mt-3"
                              style={{ objectFit: 'cover' }}
                            />

                            <div className="flex flex-column">
                              {!!member.name && (
                                <h3 className="text-2xl uppercase mb-2 gradient-text text-center underline">
                                  {member.name}
                                </h3>
                              )}
                              {!!member.name && (
                                <h4 className="uppercase mt-0 mb-2 text-center text-sm  opacity-80">
                                  {member.companyTitle}
                                </h4>
                              )}
                              <nav className="flex flex-row member-card-social-icons align-items-center mx-0 px-0 mt-1 mb-0 justify-content-center">
                                {!!member.instagramLink && (
                                  <a
                                    href={member.instagramLink}
                                    target="_blank"
                                    className="max-w-max mr-2 text-center ml-0"
                                    rel="noreferrer">
                                    <FontAwesomeIcon
                                      icon={faInstagram as IconProp}
                                      className="fa-fw"
                                    />
                                  </a>
                                )}
                                {!!member.facebookLink && (
                                  <a
                                    href={member.facebookLink}
                                    target="_blank"
                                    className="max-w-max mr-2 ml-0"
                                    rel="noreferrer">
                                    <FontAwesomeIcon
                                      icon={faFacebook as IconProp}
                                      className="fa-fw"
                                    />
                                  </a>
                                )}
                                {!!member.twitterLink && (
                                  <a
                                    href={member.twitterLink}
                                    target="_blank"
                                    className="max-w-max mr-2 ml-0"
                                    rel="noreferrer">
                                    <FontAwesomeIcon
                                      icon={faTwitter as IconProp}
                                      className="fa-fw"
                                    />
                                  </a>
                                )}
                                {!!member.youtubeLink && (
                                  <a
                                    href={member.youtubeLink}
                                    target="_blank"
                                    className="max-w-max mr-2 ml-0"
                                    rel="noreferrer">
                                    <FontAwesomeIcon
                                      icon={faYoutube as IconProp}
                                      className="fa-fw"
                                    />
                                  </a>
                                )}
                                {!!member.linkedinLink && (
                                  <a
                                    href={member.linkedinLink}
                                    target="_blank"
                                    className="max-w-max mr-2 ml-0"
                                    rel="noreferrer">
                                    <FontAwesomeIcon
                                      icon={faLinkedin as IconProp}
                                      className="fa-fw"
                                    />
                                  </a>
                                )}
                                {!!member.email && (
                                  <a
                                    href={`mailto:${member.email}`}
                                    target="_blank"
                                    className="max-w-max mr-2 ml-0"
                                    rel="noreferrer">
                                    <FontAwesomeIcon
                                      icon={faEnvelope as IconProp}
                                      className="fa-fw"
                                    />
                                  </a>
                                )}
                                {!!member.phoneNumber && (
                                  <a
                                    href={`tel:${member.phoneNumber}`}
                                    target="_blank"
                                    className="max-w-max mr-2 ml-0"
                                    rel="noreferrer">
                                    <FontAwesomeIcon
                                      icon={faPhone as IconProp}
                                      className="fa-fw"
                                    />
                                  </a>
                                )}
                              </nav>
                              <button
                                type="button"
                                className="bg-none text-white theme-border-wht border-1 px-4 md:px-4 py-2 theme-button max-w-max block no-underline my-4 font-bold w-full mx-auto border-round text-xs"
                                onClick={() => {
                                  setSelctedMember(member);
                                  setVisible(true);
                                }}>
                                <span className="opacity-80">Info</span>
                                <FontAwesomeIcon
                                  icon={faArrowUpRightFromSquare as IconProp}
                                  className="fa-fw fa-sm ml-2"
                                />
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <Link
                          to={`/1/${member.memberType?.toLocaleLowerCase()}/${
                            member.memberSlug
                          }`}
                          className="talent-card h-full no-underline animate-col-width mx-auto"
                          key={member.memberSlug}>
                          <img
                            src={member.avatarImage?.url}
                            alt=""
                            className="talent-card-image"
                          />
                          <h4 className="my-0 py-0 flex align-items-center">
                            <span>{member.name}</span>
                            <FontAwesomeIcon
                              icon={faArrowRight as IconProp}
                              className="fa-fw"
                            />
                          </h4>
                        </Link>
                      )}
                    </div>
                  ))}
              </div>
            </div>
          </section>
        </div>
      )}
      <Dialog
        visible={visible}
        onHide={() => setVisible(false)}
        breakpoints={{ '1200px': '40vw', '960px': '75vw', '640px': '90vw' }}
        style={{ width: '40vw' }}
        dismissableMask
        draggable={false}>
        <div className="member-card-content px-4">
          <img
            src={selectedMember?.avatarImage?.url}
            alt={(selectedMember?.name && selectedMember.name) || ''}
            className="border-1 mx-auto block"
            style={{
              width: '120px',
              height: '120px',
              objectFit: 'cover',
              borderRadius: '50%',
            }}
          />
          {!!selectedMember?.name && (
            <h3 className="text-2xl uppercase mb-2 gradient-text text-center underline">
              {selectedMember.name}
            </h3>
          )}
          {!!selectedMember?.welcomeQuote && (
            <p className="text-sm mt-0 py-0 mb-2 uppercase text-center">
              {selectedMember.welcomeQuote}
            </p>
          )}
          <nav className="flex flex-row member-card-social-icons align-items-center mx-0 px-0 mt-1 mb-0 justify-content-center">
            {!!selectedMember?.instagramLink && (
              <a
                href={selectedMember.instagramLink}
                target="_blank"
                className="max-w-max mr-2 text-center ml-0"
                rel="noreferrer">
                <FontAwesomeIcon
                  icon={faInstagram as IconProp}
                  className="fa-fw"
                />
              </a>
            )}
            {!!selectedMember?.facebookLink && (
              <a
                href={selectedMember.facebookLink}
                target="_blank"
                className="max-w-max mr-2 ml-0"
                rel="noreferrer">
                <FontAwesomeIcon
                  icon={faFacebook as IconProp}
                  className="fa-fw"
                />
              </a>
            )}
            {!!selectedMember?.twitterLink && (
              <a
                href={selectedMember.twitterLink}
                target="_blank"
                className="max-w-max mr-2 ml-0"
                rel="noreferrer">
                <FontAwesomeIcon
                  icon={faTwitter as IconProp}
                  className="fa-fw"
                />
              </a>
            )}
            {!!selectedMember?.youtubeLink && (
              <a
                href={selectedMember.youtubeLink}
                target="_blank"
                className="max-w-max mr-2 ml-0"
                rel="noreferrer">
                <FontAwesomeIcon
                  icon={faYoutube as IconProp}
                  className="fa-fw"
                />
              </a>
            )}

            {!!selectedMember?.linkedinLink && (
              <a
                href={selectedMember.linkedinLink}
                target="_blank"
                className="max-w-max mr-2 ml-0"
                rel="noreferrer">
                <FontAwesomeIcon
                  icon={faLinkedin as IconProp}
                  className="fa-fw"
                />
              </a>
            )}
            {!!selectedMember?.email && (
              <a
                href={`mailto:${selectedMember.email}`}
                target="_blank"
                className="max-w-max mr-2 ml-0"
                rel="noreferrer">
                <FontAwesomeIcon
                  icon={faEnvelope as IconProp}
                  className="fa-fw"
                />
              </a>
            )}
            {!!selectedMember?.phoneNumber && (
              <a
                href={selectedMember.phoneNumber}
                target="_blank"
                className="max-w-max mr-2 ml-0"
                rel="noreferrer">
                <FontAwesomeIcon icon={faPhone as IconProp} className="fa-fw" />
              </a>
            )}
          </nav>
          {!!selectedMember?.fullBio && (
            <div className="body-parsed-text">
              {parse(selectedMember.fullBio?.html)}
            </div>
          )}
        </div>
      </Dialog>
    </div>
  );
}
